import React, { useState } from "react";
import { Button, Card, Col, Form, Input, message, Row } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useFirebase } from "react-redux-firebase";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { login } from "../../../../urls";

const backgroundStyle = {
  backgroundImage: "url(/img/others/img-17.jpg)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};

const ForgotPassword = () => {
  const { t } = useTranslation();
  const firebase = useFirebase();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = (values) => {
    setLoading(true);
    firebase
      .resetPassword(values.email)
      .then(() => {
        setLoading(false);
        form.resetFields(["email"]);
        message.success(t("notifications.password_reset_send"), 6);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  };

  return (
    <div className="h-100" style={backgroundStyle}>
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={20} sm={20} md={20} lg={9}>
            <Card>
              <div className="my-2">
                <div className="text-center">
                  <img className="img-fluid w-75" src="/img/logo.png" alt="" />
                  <h3 className="mt-3 font-weight-bold">{t("forgot_password")}</h3>
                  <p className="mb-4">{t("form.enter_email")}</p>
                </div>
                <Row justify="center">
                  <Col xs={24} sm={24} md={20} lg={20}>
                    <Form form={form} layout="vertical" name="forgot-password" onFinish={onSubmit}>
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: t("form.enter_email"),
                          },
                          {
                            type: "email",
                            message: t("form.enter_valid_email"),
                          },
                        ]}
                      >
                        <Input placeholder={t("email")} prefix={<MailOutlined className="text-primary" />} />
                      </Form.Item>
                      <Form.Item>
                        <Button loading={loading} type="primary" htmlType="submit" block>
                          {t("reset")}
                        </Button>
                      </Form.Item>
                      <ToLoginLink to={login}>{t("login")}</ToLoginLink>
                    </Form>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const ToLoginLink = styled(Link)`
  text-decoration: none;
`;

export default ForgotPassword;
